import { t, ChartMetadata, ChartPlugin } from '@superset-ui/core';
import buildQuery from './buildQuery';
import controlPanel from './controlPanel';
import transformProps from './transformProps';
import thumbnail from '../images/thumbnail.png';
import ColorMapControl from './ColorMapControl';
import { getChartControlPanelRegistry } from '@superset-ui/core';

export default class RaisingFallingChartPlugin extends ChartPlugin {
  constructor() {
    const metadata = new ChartMetadata({
      name: t('Raising Falling Gantt Chart'),
      description: t('Visualize a raising event on the gantt chart'),
      thumbnail,
      tags: [t('Event'), t('Raising-Falling'), t('Timeline')],
    });
    getChartControlPanelRegistry().registerValue('ColorMapControl', {
      name: 'ColorMapControl',
      config: {
        type: 'ReactComponent',
        renderTrigger: true,
        label: t('Color Mapping'),
        description: t('Mapping warna untuk setiap kategori'),
        default: JSON.stringify([
          { category: 'Running', color: '#008000' },
          { category: 'Stop', color: '#FF0000' },
          { category: 'Idle', color: '#FFFF00' },
          { category: 'Rest', color: '#0000FF' },
          { category: 'Status_On', color: '#008000' },
          { category: 'Status_Off', color: '#FF0000' },
        ]),
        render: (props: any) => <>aaaaaaaaaaaaaaaaaaaaa</>,
        // component: ColorMapControl,
      },
    });
    super({
      buildQuery,
      controlPanel,
      loadChart: () => import('./GanttChart'),
      metadata,
      transformProps,
    });
  }
}
